/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-11-ge6c01455-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExternalHostsInfo interface.
 */
export function instanceOfExternalHostsInfo(value) {
    return true;
}
export function ExternalHostsInfoFromJSON(json) {
    return ExternalHostsInfoFromJSONTyped(json, false);
}
export function ExternalHostsInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ssh': json['ssh'] == null ? undefined : json['ssh'],
        'http': json['http'] == null ? undefined : json['http'],
        'mysql': json['mysql'] == null ? undefined : json['mysql'],
        'postgres': json['postgres'] == null ? undefined : json['postgres'],
        'kubernetes': json['kubernetes'] == null ? undefined : json['kubernetes'],
    };
}
export function ExternalHostsInfoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'ssh': value['ssh'],
        'http': value['http'],
        'mysql': value['mysql'],
        'postgres': value['postgres'],
        'kubernetes': value['kubernetes'],
    };
}
